<template>
  <div class="-top">
    <p class="title">
      {{title}}
      <el-tooltip class="item" effect="dark" :content="tip"
                  placement="top">
        <i class="iconfont el-icon-damai-bangzhu" style="width: 22px;height: 22px;text-align: center;line-height: 20px;"></i>
      </el-tooltip>
    </p>
    <p class="content">{{content}}</p>
    <!--<p class="footer">日环比-->
    <!--{{annularRatio ? (annularRatio * 100) : '-'}}-->
    <!--%-->
    <!--<i v-if="annularRatio * 1 < 0" class="el-icon-arrow-down"></i>-->
    <!--<i v-else-if="annularRatio * 1 > 0" class="el-icon-arrow-up"></i>-->
    <!--</p>-->
  </div>
</template>

<script>
  export default {
    name: 'overview-box',
    props: {
      title: {
        type: String
      },
      content: {
        type: String
      },
      tip: {
        type: String
      },
      annularRatio: {
        type: String
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../../components/common/styles/fun_var";

  .-top {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;

    border: @common-border-style;
    margin: 10px 30px;
    height: 140px;
    padding: 6px 0;
    cursor: pointer;

    &:hover {
      border: @common-border-style-hover;
    }
  }

  .title {
    font-size: 16px;
  }

  .content {
    color: #00A0E6;
    font-size: 20px;
    font-weight: bold;
  }

  .footer {
    color: #A6A6A6;
    font-size: 14px;
  }

  .el-icon-arrow-down {
    color: #66C024;
  }

  .el-icon-arrow-up {
    color: red;
    font-weight: bold;
  }

  p {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/ElectronicControl/electronic-statistics/_overview-box.vue